/**
 * Resolves admin navigation target when clicking a Document Library activity log entry.
 */
export function resolveDocumentLibraryActivityTarget({
  entityType,
  hcQuestionnaireId,
  vqaRequestId,
}) {
  const kind = String(entityType ?? "").toUpperCase();

  if (kind === "RFI" && hcQuestionnaireId != null && hcQuestionnaireId !== "") {
    return `/RFI/${hcQuestionnaireId}/Details`;
  }

  if (kind === "VQA" && vqaRequestId) {
    return `/Backend/Assessment/${vqaRequestId}/Manage`;
  }

  return null;
}

function resolveRequestSectionTarget(section, documentNavigation) {
  const documentTarget = resolveDocumentLibraryActivityTarget(documentNavigation);
  if (documentTarget) {
    return documentTarget;
  }

  for (const event of section?.events ?? []) {
    const requestTarget = resolveDocumentLibraryActivityTarget({
      entityType: "RFI",
      hcQuestionnaireId: event?.hc_questionnaire_id,
    });
    if (requestTarget) {
      return requestTarget;
    }
  }

  return null;
}

/**
 * Resolves navigation for a single activity log section, using document-level ids first
 * and per-request questionnaire ids for legacy VQQ rows when needed.
 */
export function resolveDocumentLibraryActivitySectionTarget(
  section,
  documentNavigation
) {
  if (!section) {
    return null;
  }

  if (section.type === "request") {
    return resolveRequestSectionTarget(section, documentNavigation);
  }

  return resolveDocumentLibraryActivityTarget(documentNavigation);
}

export function buildDocumentLibraryActivityNavigation({
  activityNavigation,
  entityType,
  hcQuestionnaireId,
  vqaRequestId,
}) {
  return {
    entityType:
      activityNavigation?.entity_type ??
      activityNavigation?.entityType ??
      entityType,
    hcQuestionnaireId:
      activityNavigation?.hc_questionnaire_id ??
      activityNavigation?.hcQuestionnaireId ??
      hcQuestionnaireId,
    vqaRequestId:
      activityNavigation?.vqa_request_id ??
      activityNavigation?.vqaRequestId ??
      vqaRequestId,
  };
}
